
import { Component, Prop, Vue } from 'vue-property-decorator';
import BadgeColor from '@/entities/BadgeColor';

@Component
export default class Badge extends Vue {
	@Prop({ type: String, required: true }) readonly value!: string;
	@Prop({ type: String, required: true }) readonly color!: BadgeColor;
	@Prop({ type: String, default: 'normal' }) readonly size!: string;
	@Prop({ type: String, default: undefined }) readonly styleClasses!: string;

	BadgeColor: typeof BadgeColor = BadgeColor;

	get classes(): Record<string, boolean> {
		return {
			[this.styleClasses]: Boolean(this.styleClasses),
			'items-center justify-center font-normal text-white':
				!this.styleClasses,
			'bg-red-200 text-red-500': this.color === this.BadgeColor.WARNING,
			'bg-badge-danger-bg text-badge-danger-text':
				this.color === this.BadgeColor.DANGER,
			'bg-blue-200 text-blue-900': this.color === this.BadgeColor.INFO,
			'bg-badge-success-bg text-badge-success-text':
				this.color === this.BadgeColor.SUCCESS,
			'bg-white border border-gray-500 text-gray-500':
				this.color === this.BadgeColor.OUTLINE,
			'border border-primary-500':
				this.color === this.BadgeColor.PRIMARY_OUTLINE,
			['h-5 text-xs']: this.size === 'normal',
			['h-6.5 text-xs min-w-28']: this.size === 'lg',
		};
	}
}
